import { useMutation } from "@tanstack/react-query";
import { updateBloomreachCredentials } from "../../api/bBloomreachApi";

export const useUpdateBloomreach = () => {
  return useMutation({
    mutationKey: ["update-bloomreach"],
    mutationFn: (data) => updateBloomreachCredentials(data),
  });
};
